<template>
    <ModalContent v-if="show" title="Välj idrott" class="idrotter-popup">
        <component
            :is="autocompleteComponent"
            name="idrott"
            label="Välj idrott"
            v-model="idrott"
            :spelareId="spelareId"
        />
        <ButtonGroup>
            <Button type="button" size="primary" @click.prevent="chooseIdrott">Välj</Button>
        </ButtonGroup>
    </ModalContent>
</template>
<script>
    import ModalContent from "@/components/generic/ModalContent.vue";
    import Button from "@/components/Button.vue";
    import ButtonGroup from "@/components/ButtonGroup.vue";
    import IdrottAutocomplete from "@/components/forms/reusables/IdrottAutocomplete.vue";
    import IdrottStatistikAutocomplete from "@/components/forms/reusables/IdrottStatistikAutocomplete.vue";

    export default {
        components: {
            ModalContent,
            Button,
            ButtonGroup,
            IdrottAutocomplete,
            IdrottStatistikAutocomplete,
        },
        props: {
            // "form" → IdrottAutocomplete (id-value, via store), "statistik" → IdrottStatistikAutocomplete (namn-value, IdrotterView)
            variant: {
                type: String,
                default: "statistik",
            },
            // Skickas vidare till autocompleten (begränsar t.ex. till en spelares idrotter)
            spelareId: {
                type: String,
                default: undefined,
            },
        },
        data() {
            return {
                idrott: "",
                show: true,
            };
        },
        computed: {
            autocompleteComponent() {
                return this.variant === "form" ? "IdrottAutocomplete" : "IdrottStatistikAutocomplete";
            },
        },
        methods: {
            chooseIdrott() {
                if (this.idrott) {
                    this.show = false;
                    this.$emit("chooseIdrott", this.idrott);
                }
            },
        },
    };
</script>
